import { useMemo } from 'react'
import { Contract } from '@ethersproject/contracts'
import BAKERY_ARTWORKS_NFT_ABI from '../../utils/lib/abi/artworkNFT.json'

// utils
import { getContract } from '../../utils'

// hooks
import { useActiveWeb3React } from '../'
import useYam from '../bakery/useYam'

// sushi/utils
import {
  getReviewAddress,
  getMintAddress
} from '../../sushi/utils'

import { userNftAddress } from '../../userType/userNftAddress'

export function useMintAddress() {
  const sushi = useYam()
  return getMintAddress(sushi)
}

export function useReviewAddress() {
  const sushi = useYam()
  return getReviewAddress(sushi)
}

// returns null on errors
export function useContract(address: string | undefined, ABI: any, withSignerIfPossible = true): Contract | null {
  const { library, account } = useActiveWeb3React()

  return useMemo(() => {
    if (!address || !ABI || !library) return null
    try {
      return getContract(address, ABI, library, withSignerIfPossible && account ? account : undefined)
    } catch (error) {
      console.error('Failed to get contract', error)
      return null
    }
  }, [address, ABI, library, withSignerIfPossible, account])
}

export function useDigitalArtworkNftContract(type: string, withSignerIfPossible?: boolean): Contract | null {
  const sushi = useYam()
  let nftAddress = userNftAddress(sushi, type)
  return useContract(nftAddress, BAKERY_ARTWORKS_NFT_ABI, withSignerIfPossible)
}
